var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1868 9.08347C19.1868 5.17795 15.9628 2.00073 11.9999 2.00073C8.03693 2.00073 4.81299 5.17795 4.81299 9.08347C4.81299 12.7064 7.5892 15.6983 11.1544 16.1129V17.8327H9.46333C8.9966 17.8327 8.61781 18.206 8.61781 18.666C8.61781 19.126 8.9966 19.4993 9.46333 19.4993H11.1544V21.1658C11.1544 21.6257 11.5332 21.999 11.9999 21.999C12.4666 21.999 12.8454 21.6257 12.8454 21.1658V19.4993H14.5364C15.0032 19.4993 15.3819 19.126 15.3819 18.666C15.3819 18.206 15.0032 17.8327 14.5364 17.8327H12.8454V16.1129C16.4106 15.6983 19.1868 12.7064 19.1868 9.08347ZM6.50402 9.08347C6.50402 6.09707 8.96956 3.66726 11.9999 3.66726C15.0302 3.66726 17.4957 6.09707 17.4957 9.08347C17.4957 12.0699 15.0302 14.4997 11.9999 14.4997C8.96956 14.4997 6.50402 12.0699 6.50402 9.08347Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDFemale);
export default __webpack_public_path__ + "static/media/D_Female.a1512055ab838d25bd6c747560a367da.svg";
export { ForwardRef as ReactComponent };